import { HEALTH_PRODUCTS, METHOD } from "../../consts"
import { axiosClient } from "../../service"
import { REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_CONTEXT_VENDOR, REACT_APP_VAM_ENDPOINT } from "../../urls"
import { validateEmail, validatePAN } from "../../utilFunctions"

export const defaultVendorFileData = {
    docID: 0,
    docName: null,
    docType: null,
    docURL: null,
    fileType: null,
    isFileLoading: false
}

const getDocumentURLs = async (data, keysForDocUrls, docUrls, setDocUrls) => {
    let updatedUrls = { ...docUrls }
    keysForDocUrls.map(async key => {
        if (data[key]?.docID) {
            axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}`)({ url: `${data[key]?.docID}`, method: METHOD.GET }).then(urlData => {
                setDocUrls(prev => ({ ...prev, [key]: urlData.data.docURL }))
            })
        }
    })
    setDocUrls(updatedUrls)
}

const getParsedFileDate = (stringifiedFileData) => {
    try {
        return JSON.parse(stringifiedFileData)
    } catch (error) {
        console.error(error)
        return defaultVendorFileData
    }
}
export const getVendorData = (setCreateVendorData, getDistricList, getDistrictAllocationList, getMandalList, getMandalAllocationList, getVillageList, keysForDocUrls, docUrls, setDocUrls) => {
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}`)({
        url: `getVendor/${localStorage.getItem("id")}`,
        method: METHOD.GET
    }).then(data => {
        const vendorData = { ...data.data }
        const modifiedData = {
            ...vendorData,
            "memorandumOfArticles": getParsedFileDate(vendorData.memorandumOfArticles),
            "associationOfArticles": getParsedFileDate(vendorData.associationOfArticles),
            "certificateOfIncorporation": getParsedFileDate(vendorData.certificateOfIncorporation),
            "udyamRegistration": getParsedFileDate(vendorData.udyamRegistration),
            "forLLPandPartnershipLLPDeed": getParsedFileDate(vendorData.forLLPandPartnershipLLPDeed),
            "llpRegistration": getParsedFileDate(vendorData.llpRegistration),
            "gst": getParsedFileDate(vendorData.gst),
            "pan": getParsedFileDate(vendorData.pan),
            "issla": getParsedFileDate(vendorData.issla),
            "cancelledChequeOrBankPassbook": getParsedFileDate(vendorData.cancelledChequeOrBankPassbook),
        }
        getDocumentURLs(modifiedData, keysForDocUrls, docUrls, setDocUrls)
        setCreateVendorData(modifiedData)
        getDistricList(vendorData.state)
        getDistrictAllocationList(vendorData.stateForAllocationDetails)
        getMandalList(vendorData.district, vendorData.state)
        getMandalAllocationList(vendorData.districtForAllocationDetails, vendorData.stateForAllocationDetails)
        getVillageList(vendorData.mandal, vendorData.district, vendorData.state)
    }).catch(error => {
        console.log(error)
    })
};


function validateObject(vendorDetails) {
    let optionalFields = ['mandal', 'village', 'firmCategory', 'enterpriseCategory', 'udyamRegistration', 'llpRegistration', 'issla', 'product', 'districtForAllocationDetails', 'tehsilOrMandal'];
    // remaining all fields are mandatory

    for (let key in vendorDetails) {
        // if field is undefined or null  or  '' and field is in optional fields array, continue the loop and check the next key
        if (vendorDetails[key] === undefined || vendorDetails[key] === null || vendorDetails[key] === '') {
            if (optionalFields.includes(key)) {
                continue;
            }
            return false;
        }
    }
    return true;
}

export function validateRequiredDocuments(documentDetails) {
    const ignoreTheseKeys = ['createdDate', 'createdBy', 'source']
    for (let key in documentDetails) {
      if ((documentDetails[key] === undefined || documentDetails[key] === null || documentDetails[key] === '') && !ignoreTheseKeys.includes(key)) {
        return false;
      }
    }
    return true;
  }

export const createVendorMaster = (createVendorData, toast, cancelCreateVendorMaster) => {
    if (!validateObject(createVendorData) || !validateRequiredDocuments(createVendorData.memorandumOfArticles) || !validateRequiredDocuments(createVendorData.associationOfArticles) || !validateRequiredDocuments(createVendorData.certificateOfIncorporation) || !validateRequiredDocuments(createVendorData.forLLPandPartnershipLLPDeed) || !validateRequiredDocuments(createVendorData.gst) || !validateRequiredDocuments(createVendorData.pan) || !validateRequiredDocuments(createVendorData.cancelledChequeOrBankPassbook)) {
        toast.error("Please Fill All Required Fields")
        return
    }

    if (createVendorData.bankAccountNumber !== createVendorData.reenterBankAccountNumber) {
        toast.error("Bank Account Number and Re-Entered Bank Account Number Should be the Same.")
        return
    }

    if(!validateEmail(createVendorData.email)) {
        toast.error("Please Enter Valid Email.")
        return
    }

    if (!validatePAN(createVendorData.panNumber)) {
        toast.error("Please Enter Valid PAN Number.")
        return
    }
    if (createVendorData.mobileNumber.length !== 10) {
        toast.error("Please Enter Valid Mobile Number.")
        return
    }
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}`)({
        url: `${localStorage.getItem("id") ? 'updateVendorMasterCreation' : 'saveVendorMasterCreation'}`,
        method: METHOD.POST,
        data: {
            ...createVendorData,
            "cancelledChequeOrBankPassbook": JSON.stringify(createVendorData.cancelledChequeOrBankPassbook),
            "memorandumOfArticles": JSON.stringify(createVendorData.memorandumOfArticles),
            "associationOfArticles": JSON.stringify(createVendorData.associationOfArticles),
            "certificateOfIncorporation": JSON.stringify(createVendorData.certificateOfIncorporation),
            "udyamRegistration": JSON.stringify(createVendorData.udyamRegistration),
            "forLLPandPartnershipLLPDeed": JSON.stringify(createVendorData.forLLPandPartnershipLLPDeed),
            "llpRegistration": JSON.stringify(createVendorData.llpRegistration),
            "gst": JSON.stringify(createVendorData.gst),
            "pan": JSON.stringify(createVendorData.pan),
            "issla": JSON.stringify(createVendorData.issla),
        }
    }).then(data => {
        toast.success(data.data.message)
        cancelCreateVendorMaster()
    }).catch(error => {
        if (error?.response?.status === 500) toast.error("A vendor with similar details already exists")
        console.log(error)
    })
}

export const getVendorsList = (setVendorsList, includeVendorName = false, isHealth = false) => {
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}`)({
        method: METHOD.GET,
        url: 'getVendorList/Survey',
    })
        .then(data => {
            if (setVendorsList) {
                let vendors;
                let vendorList;
                if (isHealth) {
                    vendors = data.data.filter(item => HEALTH_PRODUCTS.includes(Number(item?.productId)))
                } else {
                    vendors = data.data.filter(item => !HEALTH_PRODUCTS.includes(Number(item?.productId)))
                }
                vendorList = vendors?.map(item => {
                    const option = {
                        id: item.vendorId,
                        label: `${item.vendorName} (${item.state})`,
                        value: item.vendorId
                    };
                    if (includeVendorName) {
                        option.vendorName = item.vendorName;
                    }
                    return option;
                });
                setVendorsList(vendorList);
            }
        })
        .catch(error => {
            console.error("Error fetching vendor list:", error);
        });
};


export const enterpriseCategoryOptions = [
    {
        label:"Paddy",
        value: "Paddy"
    },
    {
        label:"Wheat",
        value: "Wheat"
    },
    {
        label:"Peas",
        value: "Peas"
    }
]